export default __webpack_public_path__ + "static/media/marca_colorida_open_finance.d067d6de.jpg";